var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"productServiceSeting"},[_c('a-card',{staticClass:"card",attrs:{"title":"基本设置","bordered":false}},[_c('BaseSet')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }